import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISelectOption } from '@apps-common/types/form'

export const QUERY_MANAGEMENT_GET_UNIT_TASK_GROUP_TYPES = () => ['getUnitTaskGroupTypes']

export const getUnitTaskGroupTypes = async (): Promise<ISelectOption[]> =>
  axios.get('/management/UnitProgramTask/TaskGroupTypes').then((res) => res.data?.data)

type QueryFnType = typeof getUnitTaskGroupTypes

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useManagementGetUnitTaskGroupTypes = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_MANAGEMENT_GET_UNIT_TASK_GROUP_TYPES(),
    queryFn: () => getUnitTaskGroupTypes()
  })
